export const projects = [
  {
    id: 'grocery',
    number: '01',
    title: 'FreshTrug',
    result: '0 → ₹50L/month\nin 7 months',
    description: 'Built the first reliable grocery delivery platform in tier-2 cities. Features included daily subscriptions with vacation mode, smart basket customization that learns user preferences, and slot-based delivery (9AM to 8PM) when competitors delivered at 9PM with leftovers.',
    stats: [
      { number: '10K', label: 'Total Users' },
      { number: '5K', label: 'Orders/Month' },
      { number: '60%', label: 'Retention' }
    ],
    tags: ['Design Lead', 'React', 'User Research', 'PHP Laravel'],
    link: '/grocery'
  },
  {
    id: 'zipem',
    number: '02',
    title: 'Zipem',
    result: 'Same volume,\n85% fewer riders',
    description: 'Designed revolutionary order clubbing system that allowed users to order from multiple restaurants in one delivery. Matched competitor order volumes with just 15% of their delivery fleet. Solved the unit economics problem that kills most food delivery startups.',
    stats: [
      { number: '280', label: 'Orders/Day' },
      { number: '110', label: 'Restaurants' },
      { number: '₹20L', label: 'Revenue/Mo' }
    ],
    tags: ['Co-founder', 'Product Strategy', 'UI/UX', 'Team Lead'],
    link: '/food-delivery'
  },
  {
    id: 'healthcare',
    number: '03',
    title: 'Healthcare Form Builder',
    result: '20 mins → 5 mins\nonboarding',
    description: 'Built custom form builder with conditional question logic for hospital patient onboarding. Single signature signs all forms, auto-generates PDFs, syncs with Salesforce. Hospital staff can now create unlimited forms without developer help.',
    stats: [
      { number: '2024', label: 'Recent Work' },
      { number: 'React', label: 'Frontend' },
      { number: 'HIPAA', label: 'Compliant' }
    ],
    tags: ['Full-stack', 'Salesforce', 'Node.js', 'Healthcare'],
    link: '/healthcare'
  }
];